module.exports = __webpack_public_path__ + "assets/download.32aecf55.svg";